import { convertCo2Score } from '@/data/http/utils/convert-co2-score';
import { CalculateFestivalCo2 } from '@/domain/impact-calculate-festival/entities/calculate-festival-co2.entity';

type CalculateFestivalCo2Dto = {
  unit: string;
  score: number;
  completion: number;
  sectors: {
    artists: {
      completion: number;
      score: number;
      categories: {
        catering: { score: number };
        mobility: { score: number };
        accommodation: { score: number };
        cargo: { score: number };
      };
    };
    team: {
      completion: number;
      score: number;
      categories: {
        catering: { score: number };
        mobility: { score: number };
        accommodation: { score: number };
      };
    };
    public: {
      completion: number;
      score: number;
      categories: {
        catering: { score: number };
        mobility: { score: number };
        accommodation: { score: number };
        digital: { score: number };
      };
    };
    site: {
      completion: number;
      score: number;
      categories: {
        energy: { score: number };
        water: { score: number };
        equipment: { score: number };
        waste: { score: number };
        cargo: { score: number };
        building: { score: number };
      };
    };
  };
};

export class CalculateFestivalCo2Mapper {
  static dtoToEntity(dto: CalculateFestivalCo2Dto): CalculateFestivalCo2 {
    return {
      scoreLetter: '',
      score: convertCo2Score(dto.score),
      scoreKgeCO2: dto.score,
      kgeCO2ByParticipant: 0,
      completion: dto.completion,
      sectors: {
        artists: {
          completion: dto.sectors.artists.completion,
          score: convertCo2Score(dto.sectors.artists.score),
          categories: {
            mobility: convertScoreObject(
              dto.sectors.artists.categories.mobility,
            ),
            catering: convertScoreObject(
              dto.sectors.artists.categories.catering,
            ),
            accommodation: convertScoreObject(
              dto.sectors.artists.categories.accommodation,
            ),
            cargo: convertScoreObject(dto.sectors.artists.categories.cargo),
          },
        },
        team: {
          completion: dto.sectors.team.completion,
          score: convertCo2Score(dto.sectors.team.score),
          categories: {
            mobility: convertScoreObject(dto.sectors.team.categories.mobility),
            catering: convertScoreObject(dto.sectors.team.categories.catering),
            accommodation: convertScoreObject(
              dto.sectors.team.categories.accommodation,
            ),
          },
        },
        public: {
          completion: dto.sectors.public.completion,
          score: convertCo2Score(dto.sectors.public.score),
          categories: {
            mobility: convertScoreObject(
              dto.sectors.public.categories.mobility,
            ),
            catering: convertScoreObject(
              dto.sectors.public.categories.catering,
            ),
            accommodation: convertScoreObject(
              dto.sectors.public.categories.accommodation,
            ),
            digital: convertScoreObject(dto.sectors.public.categories.digital),
          },
        },
        site: {
          completion: dto.sectors.site.completion,
          score: convertCo2Score(dto.sectors.site.score),
          categories: {
            energy: convertScoreObject(dto.sectors.site.categories.energy),
            water: convertScoreObject(dto.sectors.site.categories.water),
            equipment: convertScoreObject(
              dto.sectors.site.categories.equipment,
            ),
            waste: convertScoreObject(dto.sectors.site.categories.waste),
            cargo: convertScoreObject(dto.sectors.site.categories.cargo),
            building: convertScoreObject(dto.sectors.site.categories.building),
          },
        },
      },
    };
  }
}

function convertScoreObject(score: { score: number }) {
  return { score: convertCo2Score(score.score) };
}
